module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container outerpadding"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sets), function(set, i) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-3 col-sm-4 col-xs-12"
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('router-link', {
      attrs: {
        "to": '/photos/' + _vm.setNamePlus(set),
        "title": set.description
      }
    }, [_c('div', {
      staticClass: "panel-heading",
      staticStyle: {
        "background-color": "#530100",
        "color": "#fff"
      }
    }, [_c('strong', [_vm._v(_vm._s(set.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body",
      staticStyle: {
        "background-color": "#000",
        "color": "#fff",
        "box-shadow": "0 -12px 13px #530100 inset"
      }
    }, [_c('div', {
      staticClass: "boximg"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": set.boxThumbnail
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "label label-danger date"
    }, [_vm._v(_vm._s(_vm.formatDate(set.displayDate)))]), _vm._v(" "), _c('span', {
      staticClass: "likebut glyphicon glyphicon-tag"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(_vm.maxChars(set.description, 22)) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "badge pull-right",
      staticStyle: {
        "background-color": "#530100"
      }
    }, [_vm._v(_vm._s(set.count))])])])], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9a39e6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photos.vue
// module id = 451
// module chunks = 1